export default function Comparison() {
  const handleFreeTrial = () => {
    window.open('http://112.74.46.225:8002/admin/login?register=register', '_blank');
  };

  const comparisonData = [
    {
      num: 1,
      title: '整体差异',
      manual: '研发费用归集、核算、申报等工作全部依赖人工完成，工作量大、效率低、易出错',
      system: '系统自动归集研发费用数据，智能核算，一键生成申报报表，大幅提升工作效率'
    },
    {
      num: 2,
      title: '研发合规管理',
      manual: '研发项目立项、结项、变更等流程管理混乱，缺乏规范性，容易出现合规风险',
      system: '系统规范研发项目全生命周期管理，确保立项、结项、变更等流程合规，降低税务风险'
    },
    {
      num: 3,
      title: '研发过程资料',
      manual: '研发过程资料分散存储，查找困难，容易丢失，不利于税务稽查应对',
      system: '系统集中存储研发过程资料，支持在线查看、下载，方便税务稽查应对'
    },
    {
      num: 4,
      title: '研发工时管理',
      manual: '研发人员工时填报依赖Excel表格，数据准确性难以保证，统计分析困难',
      system: '系统提供便捷的工时填报功能，自动统计分析，确保数据准确性'
    },
    {
      num: 5,
      title: '多口径报表',
      manual: '会计核算、高新认定、加计扣除和IPO监管层面对研发费用归集口径要求不一，财务人员难以完整认知，造成张冠李戴，需成风险',
      system: '智能一键生成会计核算、高新认定、加计扣除和IPO监管层面等研发费用多口径、多维度报表'
    },
    {
      num: 6,
      title: '留存备查资料',
      manual: '留存备查资料手工整理归档繁琐和复杂，不能按时、合规。系统的支撑留存备查',
      system: '智能一键生成研发费用加计扣除留存备查资料'
    },
    {
      num: 7,
      title: '风险预警',
      manual: '风险预警指标需要丰富的案例积累和大数据支撑，才能建立数据分析模型和风控规则库，单体公司难以独立达成',
      system: '借助在财税领域丰富的理论和实务案例积累，对企业研发费用加计扣除的数十项涉税风险点进行提前预警'
    },
    {
      num: 8,
      title: '人员离职风险',
      manual: '人工管理的状态下，研发活动过程和研发费用归集的文件资料散乱，如果人员离职，会导致文件资料遗失，导致不可挽回的损失',
      system: '软件系统及时收集研发活动过程和研发费用归集的文件资料，系统实时留存归档，不会因人员变动导致文件资料遗失的情形'
    }
  ];

  return (
    <section className="py-12 sm:py-16 md:py-20 lg:py-24 bg-gradient-to-br from-gray-50 via-blue-50 to-teal-50 relative overflow-hidden">
      {/* 装饰性背景 */}
      <div className="absolute top-0 right-0 w-[400px] sm:w-[600px] h-[400px] sm:h-[600px] bg-gradient-to-br from-teal-200/40 to-blue-200/40 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-[350px] sm:w-[500px] h-[350px] sm:h-[500px] bg-gradient-to-br from-blue-200/40 to-purple-200/40 rounded-full blur-3xl"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 relative z-10">
        {/* 优化的标题区域 */}
        <div className="text-center mb-10 sm:mb-12 md:mb-14">
          <div className="inline-flex items-center bg-white/80 backdrop-blur-sm text-teal-700 px-4 sm:px-5 md:px-6 py-2 sm:py-2.5 md:py-3 rounded-full text-xs sm:text-sm font-bold mb-4 sm:mb-5 md:mb-6 border-2 border-teal-200 shadow-lg">
            <i className="ri-contrast-2-line mr-1.5 sm:mr-2 text-base sm:text-lg"></i>
            系统上线之后与人工管理的区别
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold text-gray-900 mb-4 sm:mb-5 md:mb-6 leading-tight px-4">
            告别传统人工管理
            <span className="block mt-2 sm:mt-3 bg-gradient-to-r from-teal-600 via-blue-600 to-purple-600 bg-clip-text text-transparent">
              拥抱智能化管理系统
            </span>
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-gray-700 max-w-3xl mx-auto font-medium px-4">
            从繁琐低效到智能高效，让数据说话，让系统为您工作
          </p>
        </div>

        {/* PC端表格 */}
        <div className="hidden lg:block bg-white rounded-3xl shadow-2xl overflow-hidden mb-12 border-2 border-gray-100">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-gradient-to-r from-blue-600 via-teal-600 to-blue-600 text-white">
                  <th className="py-7 px-8 text-left text-lg font-bold w-28">序号</th>
                  <th className="py-7 px-8 text-left text-lg font-bold w-48">维度</th>
                  <th className="py-7 px-8 text-left text-lg font-bold">人工管理</th>
                  <th className="py-7 px-8 text-left text-lg font-bold">合规智能管理系统</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {comparisonData.map((row) => (
                  <tr key={row.num} className="hover:bg-gradient-to-r hover:from-teal-50 hover:to-blue-50 transition-all duration-300">
                    <td className="py-7 px-8">
                      <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-teal-500 to-blue-500 text-white flex items-center justify-center font-bold text-xl shadow-lg">
                        {row.num}
                      </div>
                    </td>
                    <td className="py-7 px-8 font-bold text-gray-900 text-lg">{row.title}</td>
                    <td className="py-7 px-8 text-gray-700">
                      <div className="flex items-start gap-4">
                        <i className="ri-close-circle-fill text-red-500 text-2xl mt-1 flex-shrink-0"></i>
                        <span className="leading-relaxed">{row.manual}</span>
                      </div>
                    </td>
                    <td className="py-7 px-8 text-gray-700">
                      <div className="flex items-start gap-4">
                        <i className="ri-checkbox-circle-fill text-green-500 text-2xl mt-1 flex-shrink-0"></i>
                        <span className="leading-relaxed">{row.system}</span>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* 移动端卡片 */}
        <div className="lg:hidden space-y-4 sm:space-y-6 mb-8 sm:mb-12">
          {comparisonData.map((row) => (
            <div key={row.num} className="bg-white rounded-2xl sm:rounded-3xl shadow-lg p-4 sm:p-6 border-2 border-gray-100">
              <div className="flex items-center gap-3 sm:gap-4 mb-4 sm:mb-5">
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl sm:rounded-2xl bg-gradient-to-br from-teal-500 to-blue-500 text-white flex items-center justify-center font-bold text-lg sm:text-xl shadow-lg flex-shrink-0">
                  {row.num}
                </div>
                <h4 className="font-bold text-gray-900 text-base sm:text-lg">{row.title}</h4>
              </div>
              
              <div className="space-y-3 sm:space-y-4">
                <div className="bg-red-50 rounded-xl sm:rounded-2xl p-3 sm:p-4 border border-red-100">
                  <div className="flex items-center gap-2 mb-2">
                    <i className="ri-close-circle-fill text-red-500 text-lg sm:text-xl"></i>
                    <span className="font-semibold text-red-700 text-sm sm:text-base">人工管理</span>
                  </div>
                  <p className="text-gray-700 text-xs sm:text-sm leading-relaxed pl-6 sm:pl-7">{row.manual}</p>
                </div>
                
                <div className="bg-green-50 rounded-xl sm:rounded-2xl p-3 sm:p-4 border border-green-100">
                  <div className="flex items-center gap-2 mb-2">
                    <i className="ri-checkbox-circle-fill text-green-500 text-lg sm:text-xl"></i>
                    <span className="font-semibold text-green-700 text-sm sm:text-base">智能系统</span>
                  </div>
                  <p className="text-gray-700 text-xs sm:text-sm leading-relaxed pl-6 sm:pl-7">{row.system}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* 优化的底部总结对比 */}
        <div className="grid md:grid-cols-2 gap-6 sm:gap-8 mb-8 sm:mb-10 md:mb-12">
          {/* 人工管理痛点 */}
          <div className="relative bg-white rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-12 border-2 sm:border-3 border-red-200 shadow-2xl overflow-hidden group hover:shadow-3xl transition-all duration-500">
            <div className="absolute inset-0 bg-gradient-to-br from-red-50 to-orange-50 opacity-50"></div>
            <div className="relative z-10">
              <div className="flex items-center gap-3 sm:gap-4 md:gap-5 mb-6 sm:mb-8 md:mb-10">
                <div className="w-14 h-14 sm:w-16 sm:h-16 md:w-20 md:h-20 rounded-xl sm:rounded-2xl bg-gradient-to-br from-red-500 to-orange-500 flex items-center justify-center shadow-xl group-hover:scale-110 group-hover:rotate-6 transition-all duration-500">
                  <i className="ri-error-warning-line text-white text-2xl sm:text-3xl md:text-4xl"></i>
                </div>
                <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900">人工管理的痛点</h3>
              </div>
              <ul className="space-y-3 sm:space-y-4 md:space-y-5">
                {[
                  '工作量大、效率低、易出错',
                  '流程管理混乱，合规风险高',
                  '资料分散存储，查找困难',
                  '数据准确性难以保证'
                ].map((item, idx) => (
                  <li key={idx} className="flex items-start gap-2 sm:gap-3 md:gap-4 text-gray-700">
                    <i className="ri-close-circle-fill text-red-500 text-lg sm:text-xl md:text-2xl mt-0.5 flex-shrink-0"></i>
                    <span className="text-sm sm:text-base md:text-lg leading-relaxed font-medium">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* 智能系统优势 */}
          <div className="relative bg-white rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-12 border-2 sm:border-3 border-teal-200 shadow-2xl overflow-hidden group hover:shadow-3xl transition-all duration-500">
            <div className="absolute inset-0 bg-gradient-to-br from-teal-50 to-blue-50 opacity-50"></div>
            <div className="relative z-10">
              <div className="flex items-center gap-3 sm:gap-4 md:gap-5 mb-6 sm:mb-8 md:mb-10">
                <div className="w-14 h-14 sm:w-16 sm:h-16 md:w-20 md:h-20 rounded-xl sm:rounded-2xl bg-gradient-to-br from-teal-500 to-blue-500 flex items-center justify-center shadow-xl group-hover:scale-110 group-hover:rotate-6 transition-all duration-500">
                  <i className="ri-checkbox-circle-line text-white text-2xl sm:text-3xl md:text-4xl"></i>
                </div>
                <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900">智能系统的优势</h3>
              </div>
              <ul className="space-y-3 sm:space-y-4 md:space-y-5">
                {[
                  '自动归集、智能核算、一键生成',
                  '规范流程管理，降低税务风险',
                  '集中存储资料，方便查阅应对',
                  '自动统计分析，确保数据准确'
                ].map((item, idx) => (
                  <li key={idx} className="flex items-start gap-2 sm:gap-3 md:gap-4 text-gray-700">
                    <i className="ri-checkbox-circle-fill text-green-500 text-lg sm:text-xl md:text-2xl mt-0.5 flex-shrink-0"></i>
                    <span className="text-sm sm:text-base md:text-lg leading-relaxed font-medium">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* 优化的行动号召 */}
        <div className="text-center">
          <button 
            onClick={handleFreeTrial}
            className="group relative bg-gradient-to-r from-teal-600 via-blue-600 to-teal-600 text-white px-8 sm:px-12 md:px-16 py-4 sm:py-5 md:py-7 rounded-xl sm:rounded-2xl text-base sm:text-lg md:text-xl font-bold hover:shadow-2xl transition-all duration-500 cursor-pointer whitespace-nowrap overflow-hidden"
          >
            <div className="absolute inset-0 bg-gradient-to-r from-blue-600 via-teal-600 to-blue-600 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            <span className="relative flex items-center justify-center">
              <i className="ri-rocket-line mr-2 sm:mr-3 text-lg sm:text-xl md:text-2xl group-hover:rotate-45 transition-transform duration-500"></i>
              立即体验智能管理系统
              <i className="ri-arrow-right-line ml-2 sm:mr-3 text-lg sm:text-xl md:text-2xl group-hover:translate-x-2 transition-transform duration-300"></i>
            </span>
          </button>
          <p className="text-gray-700 mt-6 sm:mt-7 md:mt-8 text-sm sm:text-base md:text-lg font-medium px-4">
            现在注册即可免费试用，无需费用
          </p>
        </div>
      </div>
    </section>
  );
}